import { render, staticRenderFns } from "./no-dates-selected.component.vue?vue&type=template&id=55fa7036"
import script from "./no-dates-selected.component.vue?vue&type=script&lang=ts"
export * from "./no-dates-selected.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports